import { connect } from 'react-redux';
import FeaturedResource from '../components/featured-resource';
const mapStateToProps = state => ({
	featuredResourceContent: state.posts.setFeaturedResource
})

const FeaturedResourceContainer = connect(
	mapStateToProps
)(FeaturedResource)

export default FeaturedResourceContainer



// WEBPACK FOOTER //
// ./wp-content/themes/stanleyelevator/assets/scripts/source/resource-grid/containers/featured-resource.container.js